/* global ReklamationViewModelRules, ReklamationViewModelMessages, AdressCheck */

(function () {
	const reklamationData = $(document.currentScript).data();

	const textboxHelper = new JJK.TextBoxHelper();
	textboxHelper.ToggleLabelVisibility('FormReklamation');

	window.reklamation = new JJK.Reklamation(
		reklamationData.bezirkErmittelnUrl,
		'FormReklamation',
		reklamationData.verteilschemataErmittelnUrl,
		reklamationData.kontrollinstanzErmittelnUrl,
		reklamationData.reklamationsMassnahmeErmittelnUrl,
		reklamationData.aktuelleSprache,
		reklamationData.zeigeKalenderAn,
		reklamationData.reklamationKomplett,
		reklamationData.telefonNrPflichtfeld,
		reklamationData.setzeAboReklamationAktivUrl,
		reklamationData.verteilschemaFehler,
		reklamationData.beginneMitVerteilschema
	);

	if (reklamationData.oaDateGefuellt) {
		if (reklamationData.gewaehlteVerteilschemataAny) {
			window.initialVerteilschema = reklamationData.gewaehlteVerteilschemataFirst;
		}
		window.reklamation.SetDatum($(`#day_${reklamationData.oaDate}`));
	}

	if (reklamationData.aboReklamationAktiv) {
		window.reklamation.WechselReklamationsModus('reklamationFuerAbo', true);
	}

	window.terminHelper = { contextObjekt: window.reklamation, SetDatum: window.reklamation.SetDatum };

	if (reklamationData.mitStrassendatenbankAbgleichen) {
		window.ReklamationAdressCheck = new AdressCheck(
			reklamationData.liefereStrassenUrl,
			reklamationData.liefereOrteUrl,
			reklamationData.lieferePlzsUrl,
			reklamationData.adresseGueltigUrl,
			'#ReklamationWarningBox',
			reklamationData.idForStrasse,
			reklamationData.idForHausnummer,
			reklamationData.idForOrt,
			reklamationData.idForPlz,
			reklamationData.strassendatenvorschlagAbXZeichen,
			reklamationData.idForVorwahl
		);

		window.NachlieferadresseCheck = new AdressCheck(
			reklamationData.liefereStrassenUrl,
			reklamationData.liefereOrteUrl,
			reklamationData.lieferePlzsUrl,
			reklamationData.adresseGueltigUrl,
			'#ReklamationWarningBox',
			reklamationData.idForAdresseviewmodelStrasse,
			reklamationData.idForAdresseviewmodelHausnummer,
			reklamationData.idForAdresseviewmodelOrt,
			reklamationData.idForAdresseviewmodelPlz,
			reklamationData.strassendatenvorschlagAbXZeichen
		);

		window.ReklamationAdressCheck.AdresseGueltig();
	}

	if (reklamationData.abweichendeNachlieferadresse) {
		$('#nachlieferadresse').show();
	}

	$('#FormReklamation').validate({
		rules: ReklamationViewModelRules,
		messages: ReklamationViewModelMessages,
		errorLabelContainer: '#ReklamationMessageBox',
		wrapper: 'li',
		ignore: ':hidden:not(#BenutzerMussEingeloggtSeinFehler.validate, #AnzahlGewaehlteVerteilschemata, #BezirkExistiertFuerVerteilschema, #OADate)',
		errorClass: 'is-invalid',
		validClass: 'is-valid',
		showErrors: JJK.BindAndAddCallerThis(window.reklamation, window.reklamation.JQueryValidationShowErrors, reklamationData.verteilschemaFehler),
		invalidHandler: function (form, validator) {
			if (validator.numberOfInvalids()) {
				$('#ReklamationNeu').removeClass('disabled');
			}
		},
	});

	$.validator.addMethod('range', function (value, element, param) {
		const minValue = 1;
		const maxValue = 1;

		if (value > maxValue || value < minValue) {
			return false;
		}

		return true;
	});

	window.reklamation.JQueryValidationDynamicallRules();

	jjk.initSelect2($('select:not(#SelectedVerteilschema)'));
	jjk.initSelect2($('#SelectedVerteilschema'), { width: 508 });

	$('.kontrollinstanzen').hide();
})();
